import { Import, type LucideIcon } from 'lucide-react';

/**
 * Everything the file step needs to describe one app's export. The steps and
 * the pieces under this folder never name a source themselves, so a second
 * importer is a second descriptor (and its parser in core), not a second
 * wizard.
 */
export interface ImportSource {
  id: string;
  Icon: LucideIcon;
  /** Heading of this source's option on the file step. */
  titleKey: string;
  /** One-line description of what the import does, resolved by the step's `t`; the page/header carries the title. */
  descriptionKey: string;
  /** The how-to-export steps, in order. */
  stepKeys: readonly string[];
  /** Nominative use of the third-party mark, stated so nothing reads as a partnership. */
  trademarkKey: string;
}

export const SPLITWISE_SOURCE: ImportSource = {
  id: 'splitwise',
  Icon: Import,
  titleKey: 'import:sources.splitwise.title',
  descriptionKey: 'import:entry.subtitle',
  stepKeys: [
    'import:sources.splitwise.steps.open',
    'import:sources.splitwise.steps.export',
    'import:sources.splitwise.steps.pick',
  ],
  trademarkKey: 'import:sources.splitwise.trademark',
};
